import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { PrintHelpers } from '../../../components'
import {Label} from "../../../components/prints/utils";
const borderStyle = { border: '1px solid #424242', paddingTop: '10px' }
export const IphoneCrossBorderForm = ({
  ticket
}) => {
  const { organization, device, customer} = ticket

  return (
    <ReactBootstrap.Row style={{fontSize:"20px",lineHeight:"2rem"}} className="p-2 print_zone">
      <ReactBootstrap.Row className="pl-5 pr-5">
        <ReactBootstrap.Col style={borderStyle} xs={12}>
          <PrintHelpers.Header
            legend="Iphone Cross Border Disclaimer"
            organization={organization}
          />
        </ReactBootstrap.Col>
<ReactBootstrap.Row className="ms-0 me-5" style={borderStyle}>
         <ReactBootstrap.Col className="printsection" xs={12}>
            <p style={{ lineHeight: '25px' }}>
              Mr./Mrs./Miss
              <strong className="ps-2 pe-2">
                {customer.first_name} {customer.last_name}
              </strong> ("Customer")
             has submitted device model
              <strong className="ps-2 pe-2">
                <PrintHelpers.Strong value={device.product_name} />
              </strong>
              Serial No.
              <strong className="ps-2 pe-2">
               <PrintHelpers.Strong value={device.serial_number} />
              </strong>
             for service
with <strong> {organization.name} &nbsp; </strong>
            </p>


          </ReactBootstrap.Col>


        <ReactBootstrap.Col xs={12}>
          <p>The Customer has been advised that any device offered/provided subsequently to the
Customer by  <PrintHelpers.Strong value={organization.name}/>  by way of
device replacement as per applicable Apple Policies / T&C will be a comparable device that
complies with local standards in  <PrintHelpers.Strong value={organization.country}/>
and may not necessarily be the exact model type / same frequency configuration as initially
purchased by the Customer outside <PrintHelpers.Strong value={organization.country}/>. </p>
        </ReactBootstrap.Col>


         <ReactBootstrap.Col className={"text-end"} xs={12}>
          <PrintHelpers.Strong value={organization.name}/>
        </ReactBootstrap.Col>


</ReactBootstrap.Row>

            <ReactBootstrap.Col style={borderStyle}  xs={12}>
                   <PrintHelpers.TimeStamp
            label="Data and Time"
            value={ticket.iphone_cross_border_signature_timestamp}
          />
                <p>
        <Label className="clearfix" value={'Place'} />
        {ticket.organization.city}
      </p>

            </ReactBootstrap.Col>

        <ReactBootstrap.Col style={borderStyle} className="text-left" xs={6}>
          <PrintHelpers.Signature signature={ticket.created_by_signature} />
          <PrintHelpers.InlineText value={ticket.created_by} />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} className="text-end" xs={6}>

        <PrintHelpers.InlineText value={'Customer Signature'} />
          <PrintHelpers.Signature signature={ticket.customer_iphone_cross_border_signature_s3_path} />

                <PrintHelpers.InlineText value={`${customer.first_name} ${customer.last_name}`} />

        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
    </ReactBootstrap.Row>
  )
}
